module.exports = __webpack_public_path__ + "static/media/remove.2e899b2f.svg";